import { render, staticRenderFns } from "./automobile.vue?vue&type=template&id=16f4c06a&scoped=true"
import script from "./automobile.vue?vue&type=script&lang=js"
export * from "./automobile.vue?vue&type=script&lang=js"
import style0 from "./automobile.vue?vue&type=style&index=0&id=16f4c06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f4c06a",
  null
  
)

export default component.exports